// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-badbfa82] .el-drawer__body {\n  overflow: auto;\n  padding: 16px;\n}", ""]);
// Exports
module.exports = exports;
